import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { fornecedorAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import type { Fornecedor } from "@/types/fornecedor";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: Fornecedor | null;
  onSuccess: () => void;
}

export function FornecedorDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item || item.sistema) return;
    try {
      await fornecedorAdapter.delete(item.id_fornecedor);
      toast({ title: "Sucesso", description: "Fornecedor excluído com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error) {
      toast({ title: "Erro", description: "Não foi possível excluir.", variant: "destructive" });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Fornecedor</AlertDialogTitle>
          <AlertDialogDescription>
            {item?.sistema ? "Fornecedores de sistema não podem ser excluídos." : `Tem certeza que deseja excluir permanentemente "${item?.nome}"? Esta ação não pode ser desfeita.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={item?.sistema}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
